(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eagle-moving-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eagle-moving-banner')) {
  customElements.define('eagle-moving-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.intent = 0;
      this.playing = false;
      this.step = 0;
      this.audioArea = this.querySelector('.et-moving-banner__audio');
      this.playButton = this.querySelector('[data-audio-toggle]');
      this.volume = this.querySelector('input');
      this.status = this.querySelector('[data-audio-status]');
      const belt = this.querySelector('.et-moving-banner__belt');
      const set = this.querySelector('.et-moving-banner__set');
      const originalCards = [...set.children];
      const copies = Math.max(1, Math.ceil(window.innerWidth / Math.max(set.scrollWidth, 1)));
      for (let i = 1; i < Math.min(copies, 8); i++) {
        originalCards.forEach(card => { const extra = card.cloneNode(true); extra.setAttribute('aria-hidden', 'true'); extra.setAttribute('inert', ''); set.appendChild(extra); });
      }
      const duplicate = set.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.setAttribute('inert', '');
      belt.appendChild(duplicate);
      this.querySelector('[data-motion-toggle]').addEventListener('click', event => {
        const paused = this.classList.toggle('et-moving-banner--paused');
        event.currentTarget.textContent = paused ? this.dataset.resume : this.dataset.pause;
        event.currentTarget.setAttribute('aria-pressed', String(paused));
      }, { signal });
      this.playButton.addEventListener('click', () => this.playing ? this.stopMusic() : this.startMusic(), { signal });
      this.volume.addEventListener('input', () => {
        const target = Number(this.volume.value) / 100;
        if (this.master) { this.master.gain.cancelScheduledValues(this.context.currentTime); this.master.gain.setTargetAtTime(target, this.context.currentTime, .1); }
        if (this.audio) this.audio.volume = target;
      }, { signal });
      document.addEventListener('click', event => { if (!this.audioArea.contains(event.target)) this.stopMusic(); }, { capture: true, signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stopMusic(); }, { signal });
      window.addEventListener('pagehide', () => this.stopMusic(), { signal });
      this.entranceTimer = setTimeout(() => { if (!document.hidden) this.startMusic(); }, 5000);
    }
    tone(frequency, time, duration, gain, type = 'sine') {
      const oscillator = this.context.createOscillator();
      const envelope = this.context.createGain();
      oscillator.type = type; oscillator.frequency.value = frequency;
      envelope.gain.setValueAtTime(0, time); envelope.gain.linearRampToValueAtTime(gain, time + .025); envelope.gain.exponentialRampToValueAtTime(.0001, time + duration);
      oscillator.connect(envelope); envelope.connect(this.master); oscillator.start(time); oscillator.stop(time + duration + .05);
      oscillator.onended = () => { oscillator.disconnect(); envelope.disconnect(); };
    }
    tick() {
      if (!this.playing) return;
      const melody = [261.63,329.63,392,329.63,293.66,349.23,440,349.23,220,261.63,329.63,392,196,246.94,293.66,246.94];
      const chords = [[130.81,164.81,196],[146.83,174.61,220],[110,130.81,164.81],[98,123.47,146.83]];
      const time = this.context.currentTime + .04;
      this.tone(melody[this.step % 16], time, .8, .12, 'triangle');
      if (this.step % 4 === 0) chords[Math.floor(this.step / 4) % 4].forEach(f => this.tone(f, time, 2.2, .07));
      if (this.step % 2 === 0) this.tone(chords[Math.floor(this.step / 4) % 4][0] / 2, time, .35, .16);
      this.step++;
    }
    async startMusic() {
      clearTimeout(this.entranceTimer);
      const intent = ++this.intent;
      this.status.textContent = this.dataset.blocked;
      try {
        if (this.dataset.audioUrl) {
          if (!this.audio) { this.audio = new Audio(this.dataset.audioUrl); this.audio.loop = true; this.audio.preload = 'none'; }
          this.audio.volume = 0;
          await this.audio.play();
          if (intent !== this.intent) { if (!this.playing) this.audio.pause(); return; }
          this.fadeStart = performance.now();
          const fade = now => {
            if (!this.playing || intent !== this.intent) return;
            this.audio.volume = Number(this.volume.value) / 100 * Math.min((now - this.fadeStart) / 3000, 1);
            if (now - this.fadeStart < 3000) this.fadeFrame = requestAnimationFrame(fade);
          };
          this.playing = true; this.fadeFrame = requestAnimationFrame(fade);
        } else {
          if (!this.context) {
            const AudioEngine = window.AudioContext || window.webkitAudioContext;
            if (!AudioEngine) throw new Error('Audio unavailable');
            this.context = new AudioEngine(); this.master = this.context.createGain(); this.master.gain.value = 0; this.master.connect(this.context.destination);
          }
          await this.context.resume();
          if (intent !== this.intent) { if (!this.playing) this.context.suspend(); return; }
          if (this.context.state !== 'running') return;
          this.master.gain.cancelScheduledValues(this.context.currentTime);
          this.master.gain.setValueAtTime(0, this.context.currentTime);
          this.master.gain.linearRampToValueAtTime(Number(this.volume.value) / 100, this.context.currentTime + 3);
          clearInterval(this.musicTimer); this.playing = true; this.tick(); this.musicTimer = setInterval(() => this.tick(), 600);
        }
        this.playButton.textContent = this.dataset.stop; this.playButton.setAttribute('aria-pressed', 'true'); this.status.textContent = this.dataset.playing;
      } catch { if (intent === this.intent) this.status.textContent = this.dataset.blocked; }
    }
    stopMusic() {
      this.intent++; this.playing = false; clearTimeout(this.entranceTimer); clearInterval(this.musicTimer); cancelAnimationFrame(this.fadeFrame);
      if (this.audio) this.audio.pause();
      if (this.context && this.context.state !== 'closed') { this.master.gain.cancelScheduledValues(this.context.currentTime); this.master.gain.setValueAtTime(0, this.context.currentTime); this.context.suspend(); }
      this.playButton.textContent = this.dataset.play; this.playButton.setAttribute('aria-pressed', 'false'); this.status.textContent = this.dataset.stopped;
    }
    disconnectedCallback() { this.stopMusic(); this.controller.abort(); if (this.context) this.context.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
